import { Box, Stack, Divider } from "@mui/material";
import MooneLogo from "Assets/Images/Images/moone-logo.svg";
import { BOTTOM_MENU_HEIGHT } from "Components/Layout/Menu/BottomMenu";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import { PageTitle } from "Components/Shared/PageTitles/PageTitle";
import { useIsMobile } from "Hooks/useIsMobile";
import { Resources, useResource } from "Translations/Resources";
import { type ReactNode, useEffect } from "react";

type Props = {
  title: string;
  children: ReactNode;
  onChevronClick?: () => void;
  secondaryLogo?: {
    src: string;
    alt: string;
    width?: number;
    height?: number;
  };
};

export const CampaignLayout = ({
  title,
  children,
  onChevronClick,
  secondaryLogo,
}: Props) => {
  const { t } = useResource();
  const isMobile = useIsMobile();

  useEffect(() => {
    document.title = `${title} | ${t(Resources.Common.AppName)}`;
  }, [title, t]);

  return (
    <Box
      display="flex"
      overflow="hidden"
      pb={isMobile ? BOTTOM_MENU_HEIGHT : undefined}
      justifySelf={["stretch", "center"]}
    >
      <Stack
        position="relative"
        width="100%"
        padding={({ spacing }) => [spacing(6, 3, 3, 3), spacing(6, 12)]}
        zIndex={2}
      >
        <PageTitle onChevronClick={onChevronClick}>
          <Box
            display="flex"
            alignItems="center"
            gap={2}
            sx={{ lineHeight: 0 }}
          >
            <UnstyledLink to="https://mo.one">
              <img src={MooneLogo} alt="moone logo" width={143} height={45} />
            </UnstyledLink>
            {secondaryLogo && (
              <>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    height: 45,
                    borderColor: "text.primary",
                    opacity: 0.3,
                  }}
                />
                <img
                  src={secondaryLogo.src}
                  alt={secondaryLogo.alt}
                  width={secondaryLogo.width || 45}
                  height={secondaryLogo.height || 45}
                  style={{ objectFit: "contain" }}
                />
              </>
            )}
          </Box>
        </PageTitle>
        <Box mt={[4, 6]} height="100%">
          {children}
        </Box>
      </Stack>
    </Box>
  );
};
